import axios from 'axios';
import { baseURL, CLASERVER } from './url';
import { Internal_Token } from '../components/auth/auth';
import { encrypt } from './encodingdecoding';

const api = axios.create({
  baseURL: `${CLASERVER}`,
});

const isTokenExpired = (tokenData) => {
  if (!tokenData) return true;
  try {
    const { expires_at } = JSON.parse(tokenData);
    return !expires_at || expires_at <= Math.floor(Date.now() / 1000);
  } catch (e) {
    console.error('Failed to parse token:', e);
    return true;
  }
};

const refreshToken = async () => {
  try {
    const tokenBody = {
      clientid: encrypt(process.env.REACT_APP_CLIENT_ID || 'progcap_180225062305638754565883678805'),
      grant_type: 'client_credentials',
      clientsecret: encrypt(process.env.REACT_APP_CLIENT_SECRET || 'YTVAQBLCNR'),
    };
    const internalToken = await Internal_Token(tokenBody);
    if (!internalToken?.access_token) {
      throw new Error('Invalid token response');
    }
    const tokenToStore = {
      access_token: internalToken.access_token,
      expires_at: internalToken.expires_in
        ? Math.floor(Date.now() / 1000) + internalToken.expires_in
        : Math.floor(Date.now() / 1000) + 3600,
    };
    localStorage.setItem('token_gen', JSON.stringify(tokenToStore));
    return tokenToStore.access_token;
  } catch (error) {
    console.error('Token refresh failed:', error);
    localStorage.removeItem('token_gen');
    throw error;
  }
};

api.interceptors.request.use(
  async (config) => {
    let TOKEN = localStorage.getItem('token_gen');
    let accessToken = null;

    if (TOKEN && !isTokenExpired(TOKEN)) {
      try {
        const token = JSON.parse(TOKEN);
        accessToken = token.access_token;
      } catch (e) {
        console.error('Failed to parse token:', e);
      }
    } else {
      // If token is expired or missing, refresh it
      accessToken = await refreshToken();
    }

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const newAccessToken = await refreshToken();
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return api(originalRequest);
      } catch (tokenError) {
        return Promise.reject(tokenError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;